import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { FAQ } from './faq';
import { FAQStore } from '../stores/FAQStore';
import { ProductStore } from '../stores/ProductStore';
import styles from './FAQSection.css';

const IPropTypes = {
  reference: PropTypes.func,
};

const defaultProps = {
  reference: () => { },
};

class FAQSection extends React.Component {
  componentDidMount() {
    FAQStore.fetchQuestions(ProductStore.product.id);
  }

  render() {
    if (!FAQStore.questions || !FAQStore.questions.length) {
      return null;
    }
    const { questions } = FAQStore;
    return (
      <section className={styles.container} ref={this.props.reference}>
        <h2 className={styles.title}>
          Preguntas sobre este producto
        </h2>
        <p className={styles.questionAmount}>
          {FAQStore.numberOfQuestions} pregunta{FAQStore.numberOfQuestions !== 1 ? 's' : ''} respondida{FAQStore.numberOfQuestions !== 1 ? 's' : ''}
        </p>
        {
          questions.map(questionCategory => (
            <div key={questionCategory.id}>
              <h4 className={styles.questionCategory}>
                {questionCategory.name}
              </h4>
              {
                questionCategory.questions.map(questionData => (
                  <FAQ key={questionData.question} questionData={questionData} />
                ))}
            </div>
          ))
        }
      </section>
    );
  }
}

FAQSection.propTypes = IPropTypes;
FAQSection.defaultProps = defaultProps;

const FAQSectionWrapped = observer(FAQSection);

export { FAQSectionWrapped as FAQSection };



// WEBPACK FOOTER //
// ./src/pages/product-detail/faq-section/FAQSection.jsx